import React, { useState } from "react";
import { useEffect } from "react";
import { Form } from "react-bootstrap";
import { scales } from "../../../../../colorscaleUtils";
import Gradient from "../../../../../components/Gradient";
import { DWEntityLayer } from "../../../deckgl/DWEntityLayer";
import { MapLayer } from "../../../deckgl/MapLayer";
import { dcRound } from "../../../utils/misc";

type Prop = {
    awaitedLayerUpdate: number,
    setAwaitedLayerUpdate: Function,
    index: number,
    layer2: DWEntityLayer,
    layer: MapLayer,
    onChange: () => void,
    visibleSelection: boolean,
    selectedLayerId: string | null,
    setSelectedLayerId: Function,
    setUpdateHistogramId: Function,
    setUpdateHistogramLoaded: Function,
    updateHistogramId: number,
    updateHistogramLoaded: boolean,
    dwFilters: any,
    setColorRampMaxMin: Function, 
    colorRampMaxMin: Array<number> | null, 
 };

const GLMapLayer = ({ awaitedLayerUpdate, setAwaitedLayerUpdate, index,layer2, layer, onChange, visibleSelection, selectedLayerId, setSelectedLayerId, setUpdateHistogramId, setUpdateHistogramLoaded, updateHistogramId, updateHistogramLoaded, dwFilters, setColorRampMaxMin, colorRampMaxMin }: Prop) => {
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [visible, setVisible] = useState<boolean>(layer.visible);
    const [awaitedLayer, setAwaitedLayer] = useState<MapLayer | null>(null);
    
    useEffect(() => {
        const loadData = async () => {
            console.log("D022324 layer", layer);  
            console.log("D022324 index", index);  
            if (index === 0){ // request geojson on only the first layer
                setAwaitedLayerUpdate(0);
                await layer.load();
                console.log("D022324 awaited layer", layer);
                //setAwaitedLayer(layer);
                setAwaitedLayerUpdate((prev:any) => prev + 1 );
                onChange();
                if (layer2._id === selectedLayerId){
                    layer2.getTransform(dwFilters).then(function(response:any) {
                        setColorRampMaxMin( response.find((e:any) => e.hasOwnProperty('colorRampMaxMin')) ? response.find((e:any) => e.hasOwnProperty('colorRampMaxMin')).colorRampMaxMin : null);
                        if (layer.id === selectedLayerId){
                            setUpdateHistogramId((prev:any) => prev + 1 );
                            setUpdateHistogramLoaded(true);
                        }
                    });
                }
            }
        }
 
        loadData();    
    }, []);

    useEffect(() => {
        const setData = async () => {
            //console.log("D022324 layer", layer);  
            //console.log("D022324 index", index);  
            //console.log("D022324 awaitedLayerUpdate", awaitedLayerUpdate);  
            if (index !== 0 && awaitedLayerUpdate > 0){ // assign to all but the first layer
                //let _awaitedLayer = awaitedLayer as DWEntityLayer
                //layer2._data = _awaitedLayer?._data;
                await layer.syncWithAwaited();
                onChange();
                if (layer2._id === selectedLayerId){
                    layer2.getTransform(dwFilters).then(function(response:any) {
                        setColorRampMaxMin( response.find((e:any) => e.hasOwnProperty('colorRampMaxMin')) ? response.find((e:any) => e.hasOwnProperty('colorRampMaxMin')).colorRampMaxMin : null);
                        if (layer.id === selectedLayerId){
                            setUpdateHistogramId((prev:any) => prev + 1 );
                            setUpdateHistogramLoaded(true);
                        }
                    });
                }
            }  
        }
        setData();
    }, [awaitedLayerUpdate]);
    
    useEffect(() => {
        if (layer.id === selectedLayerId){
            layer.visible = visibleSelection;
            setVisible(visibleSelection);
            onChange();
         }else{
            layer.visible = false;
            setVisible(false);
            onChange();
         }
    }, [visibleSelection, selectedLayerId, updateHistogramId]);

    useEffect(() => {
        console.log("updateHistogramLoaded", updateHistogramLoaded)
    }, [updateHistogramLoaded]);

    useEffect(() => {
        //console.log("032423 updateHistogramLoaded", updateHistogramLoaded)
        //console.log("032423 updateHistogramId", updateHistogramId)
        if (updateHistogramLoaded && (layer2._id === selectedLayerId)){
            layer2.getTransform(dwFilters).then(function(response:any) {
                //console.log("032423 response", response);
                //console.log("032423 layer", layer);
                //console.log("032423 layer2", layer2);
                //console.log("032423 selectedLayerId", selectedLayerId);
                setColorRampMaxMin( response.find((e:any) => e.hasOwnProperty('colorRampMaxMin')) ? response.find((e:any) => e.hasOwnProperty('colorRampMaxMin')).colorRampMaxMin : null);
              });
        }
    }, [updateHistogramId]);

    return (<>
            {/*console.log("D021524 colorRampMaxMin", colorRampMaxMin)}
            {console.log("D021524 layer", layer)}
    {console.log("D021524 layer2", layer2)*/}
            {(
                (layer.getColorRamp() != null) 
                && (layer.id === selectedLayerId) 
                && (layer2._name !== "Treatment (color)") 
                && (layer2._name !== "Cultivar")
                && colorRampMaxMin
            ) 
                ? <div className="mt-2">
                        <div style={{width: "100%", height: 40, textAlign: "center", }}>
                            <Gradient width={240} height={15} ramp={scales[layer.getColorRamp()!]} inverse={true} />
                            <br/>
                            <div style={{height: 15, width:240, display:'inline-block'}}>
                                <div style={{float:'left'}}>{`${(colorRampMaxMin[0]!==undefined && colorRampMaxMin[0]!==null) ? dcRound(colorRampMaxMin[0]).toString() : ""}`}</div>
                                <div style={{float:'right'}}>{`${(colorRampMaxMin[1]!==undefined && colorRampMaxMin[1]!==null) ? dcRound(colorRampMaxMin[1]).toString() : ""}`}</div>
                            </div>
                        </div>
                    </div>
                :   <div style={{width: "100%", height: "5px", textAlign: "center", }}>
                    </div>
            } 

            { errorMessage && 
                <div>{errorMessage}</div>
            }
        </>
    );
}

export default GLMapLayer;